import React from "react";
import UserIcon from "../icons/user.png";
import { formatDistance } from "date-fns";
import { Waypoint } from "react-waypoint";

const Post = ({ description, image, lastPost, loadFeed, user }) => {
  return (
    <>
      <div className="post">
        <div className="post-header">
          <div>
            <img
              src={user.avatar !== null ? user.avatar : UserIcon}
              alt="user-icon"
              className="post-icon"
            />
          </div>
          <div className="post-user">
            <span className="img-user">{user.name}</span>
            <span className="img-timestamp">
              Spotted {formatDistance(Date.parse(image.timestamp), new Date())}{" "}
              ago
            </span>
          </div>
        </div>
        <p className="img-description">{description}</p>
        <div className="img-container">
          <img src={image.url} alt="cat" className="img"></img>
        </div>
      </div>
      {lastPost && <Waypoint onEnter={loadFeed} />}
    </>
  );
};

export default Post;
